@use '@/styles/popup' as *;

.popup {
  :global(.ant-dropdown-menu) {
    @include popup-chrome;
  }

  :global(.ant-dropdown-menu-item) {
    @include popup-item;
  }

  :global(.ant-dropdown-menu-item-icon svg) {
    width: 16px;
    height: 16px;
  }
}
